import React, { useState } from "react";
import TextInput from "common/TextInput";

const AskTag = ({ tag, onChange, onApply, disabled = false }) => (
  <TextInput
    type="text"
    name="tag"
    label="Add this VLAN tag to bypass:"
    className="input-control align-right"
    defaultValue={tag}
    onChange={onChange}
    disabled={disabled}
    placeholder={"1-4094"}
    addon={
      <i className="material-icons actions-icon-color action shaded"  onClick={onApply}>add</i>
    }
  />
);

const doesNothing = () => {};

const CreateVLAN = ({ doValidate = doesNothing, doSave = doesNothing, bqn }) => {
  const [vlan, setVLAN] = useState({ tag: "" });
  const [error, setError] = useState(null);
  const handleChange = (event) => {
    try {
      const tag = parseInt(event.target.value);
      const vlan = { tag };
      doValidate(vlan);
      setError(null);
      setVLAN(vlan);
    } catch (error) {
      setError(error);
    }
  };

  const doApply = () => {
    try {
      doValidate(vlan);
      doSave(vlan);
    } catch (error) {
      setError(error);
    }
  };

  const onApply = () => {
    if (bqn === "all") {
      showModalConfirm(
        "Create tag for all BQN's?",
        "The tag will be added for all BQN's in the cluster when Applied, please use the other tabs if you want to add just for specific BQNs.",
        "warning",
        () => doApply(),
        () => null,
        "OK",
        "CANCEL",
      );
    } else {
      doApply();
    }
  };

  return (
    <>
      <div>
        <AskTag
          tag={vlan.tag}
          onChange={handleChange}
          onApply={onApply}
          error={error}
        />
      </div>
      {error !== null && (
        <div className="modal-err-msg color-red align-left">{error}</div>
      )}
    </>
  );
};
export default CreateVLAN;
